import { listOrgLearningEvents } from "./learningEventHelpers"
import { listOrgLearningSessions } from "./sessionHelpers"
import { buildBuckets } from "./dateRangeHelpers"

// One series covering all 5 chart metrics, bucketed by day (or month for 12m).
// Empty/zero for any bucket before instrumentation went live — that's correct,
// not missing data.
export const computeLearningActivitySeries = async (orgId, rangeKey) => {
  const buckets = buildBuckets(rangeKey)
  const [{ events }, { sessions }] = await Promise.all([
    listOrgLearningEvents(orgId),
    listOrgLearningSessions(orgId),
  ])

  return buckets?.map((bucket) => {
    const bucketEvents = events?.filter((e) => e?.dateKey === bucket.key) || []
    const bucketSessions = sessions?.filter((s) => s?.dateKey === bucket.key) || []

    const learnerIds = new Set()
    bucketEvents.forEach((e) => learnerIds.add(e?.userId))
    bucketSessions.forEach((s) => learnerIds.add(s?.userId))

    const hoursRaw = bucketSessions?.reduce((sum, s) => sum + (s?.durationSeconds || 0), 0) / 3600

    return {
      key: bucket.key,
      label: bucket.label,
      learners: learnerIds.size,
      sessions: bucketSessions.length,
      hours: Math.round(hoursRaw * 10) / 10,
      lessons: bucketEvents?.filter((e) => e?.type === "lesson_completed")?.length,
      assessments: bucketEvents?.filter((e) => e?.type === "assessment_completed")?.length,
    }
  })
}